var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fast-fade", mode: "out-in" } }, [
    _c(
      "div",
      { staticClass: "grow" },
      [
        _c(
          "w-drawer",
          {
            staticClass: "main-drawer",
            attrs: { hover: _vm.$wf.isSmDown, "swipe-open": "" },
            model: {
              value: _vm.drawer,
              callback: function ($$v) {
                _vm.drawer = $$v
              },
              expression: "drawer",
            },
          },
          [
            _c("w-drawer-item", { staticClass: "mts", attrs: { to: "/" } }, [
              _c("span", { staticClass: "icon icon-arrow-left" }),
              _c("span", [_vm._v(_vm._s(_vm.$ct("back")))]),
            ]),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/support/tickets" } },
              [
                _c("span", { staticClass: "icon icon-lifebuoy" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("tickets")))]),
              ]
            ),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              {
                staticClass: "mts",
                on: {
                  click: function ($event) {
                    return _vm.goToRoadMap()
                  },
                },
              },
              [
                _c("span", { staticClass: "icon icon-radio" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("changelog")))]),
              ]
            ),
            _c("w-divider"),
            _c(
              "w-drawer-item",
              { staticClass: "mts", attrs: { to: "/support/teamviewer" } },
              [
                _c("span", { staticClass: "icon icon-support" }),
                _c("span", [_vm._v(_vm._s(_vm.$ct("teamviewer")))]),
              ]
            ),
            _c("w-divider"),
          ],
          1
        ),
        _c(
          "transition",
          { attrs: { name: "fast-fade", mode: "out-in" } },
          [_c("router-view")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }